import { set } from "@/utils/vuex";

export default {
  setSalesTrackingGeneral: set("salesTrackingGeneral"),

  // Supplier Stats
  setSuppliersStats: set("suppliersStats"),
  setSuppliersCombinedStats: set("supplierCombinedStats"),
  setSuppliersMonthStats: set("supplierMonthStats"),
  setSpecificSupplierStats: set("specificSupplierStats"),
  setSupplierSalesEnquiryBuyerTypeStats: set(
    "supplierSalesEnquiryBuyerTypeStats"
  ),
  setSupplierGoodCauseCCStats: set("supplierGoodCauseCCStats"),
  setSupplierLeadsBuyerTypeStats: set("supplierLeadsBuyerTypeStats"),

  // Good Cause Stats
  setSpecificGoodCauseStats: set("specificGoodCauseStats"),
  setGoodCauseSupplierCategoryCCStats: set("goodCauseSupplierCategoryCCStats"),
  setGoodCauseSalesEnquiryBuyerTypeStats: set(
    "goodCauseSalesEnquiryBuyerTypeStats"
  ),
  setGoodCauseLeadsBuyerTypeStats: set("goodCauseLeadsBuyerTypeStats"),

  // Impact Buyer Stats
  setSpecificBuyerStats: set("specificBuyerStats"),
  setImpactBuyerChosenGoodCause: set("impactBuyerChosenGoodCause"),
};
